import { z } from 'zod';

import { PartyGenderSchema, PartyPfProfileFieldsSchema } from './party-pf-profile.schemas.js';

export const UpdatePartyBodySchema = z
  .object({
    name: z.string().trim().min(1).optional(),
    legalName: z.string().trim().nullable().optional(),
    tradeName: z.string().trim().nullable().optional(),
    stateRegistration: z.string().trim().min(1).max(20).nullable().optional(),
    document: z.string().trim().nullable().optional(),
    birthDate: z.iso.date().nullable().optional(),
    gender: PartyGenderSchema.nullable().optional(),
  })
  .extend(PartyPfProfileFieldsSchema.shape);

export type UpdatePartyBody = z.infer<typeof UpdatePartyBodySchema>;

export const UpdatePartyResponseSchema = z.object({
  partyId: z.uuid(),
  changedFields: z.array(z.string()),
});

export type UpdatePartyResponse = z.infer<typeof UpdatePartyResponseSchema>;
